export default __webpack_public_path__ + "static/media/2016_echothon1.a3d40146.jpg";